import React, {useState , useEffect} from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import p1 from '../assets/images/payment-icon/1.png';
import p2 from '../assets/images/payment-icon/2.png';
import p3 from '../assets/images/payment-icon/3.png';
import p4 from '../assets/images/payment-icon/4.png';
import p5 from '../assets/images/payment-icon/5.png';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import StripeCheckout from "react-stripe-checkout"
import axios from "axios"
import logo1 from '../assets/images/logo1.png';


import {loadStripe} from '@stripe/stripe-js';




// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";










const Checkout = (props) => {
    const [fname , setfName ] = useState("")
    const [Lname , setLName ] = useState("")
    const [Address , setAddress ] = useState("")
    const [Address1 , setAddress1 ] = useState("")
    const [Country , setCountry ] = useState("")
    const [ZipPostal , setZipPostal ] = useState("1")
    const [Email , setEmail ] = useState("")
    const [Phone , setPhone ] = useState("")
    const [DIFFERENTfname , setDIFFERENTfName ] = useState("")
    const [DIFFERENTLname , setDIFFERENTLName ] = useState("")
    const [DIFFERENTAddress , setDIFFERENTAddress ] = useState("")
    const [DIFFERENTAddress1 , setDIFFERENTAddress1 ] = useState("")
    const [DIFFERENTZipPostal , setDIFFERENTZipPostal ] = useState("")
    const [DIFFERENTEmail , setDIFFERENTEmail ] = useState("")
    const [DIFFERENTPhone , setDIFFERENTPhone ] = useState("")
    const [admindataall , setadmindataall ] = useState(0)
    const [promo , setpromo] = useState("")

    const [MainCatogories , setMainCatogories] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    const [SubClassCategories , setSubClassCategories] = useState([])

    const [photo1 , setphoto1 ] = useState("")
    const [discount , setdiscount ] = useState({})
    const [photo2 , setphoto2 ] = useState("")

    const [Order_Notes , setOrder_Notes ] = useState("")
    const [City , setCity ] = useState("")
    const [DIFFERENTOrder_Notes , setDIFFERENTOrder_Notes ] = useState("")
    const [DIFFERENTCity , setDIFFERENTCity ] = useState("")
    const [paymenttype , setpaymenttype ] = useState("")
    const [cart , setCart] = useState([])
    const [tot , setot] = useState(0)
    const [total , settotal] = useState(0)
    const [doctor , setdoctor] = useState(0)

    const [display , setdisplay] = useState(true)
    const [play , setplay] = useState(false)
    const [customPhotojson , setcustomPhotojson] = useState(false)
    const [Num1111 , setNum1111] = useState(0)
    const [SubPeice , setSubPeice] = useState(0)
    const [Num11 , setNum11] = useState(0)
    const [SubTotal , setSubTotal] = useState(0)
    const [chack, setchack] = useState(false) 
    const [chack1, setchack1] = useState(false) 
    const [paymenttype3, setpaymenttype3] = useState(false) 
    const [Cate1 , setCate1] = useState([])
    const [Cate2 , setCate2] = useState([])
    // const [Product_Image_Upload , setProduct_Image_Upload] = useState("")

//  const [stripePromise, setStripePromise] = useState(null);
//   const [clientSecret, setClientSecret] = useState("");



    useEffect(() =>{
        window.scrollTo(0, 0)
        // document.getElementById("c").style.display = "none"
        var data =  JSON.parse(localStorage.getItem("Cart")) 
        // var data1 =  JSON.parse(localStorage.getItem("CartPrice")) 
        if (data) {
            setCart(data)




      //          fetch("https://km-main-back-update.vercel.app/config").then(async (r) => {
      // const { publishableKey } = await r.json();
      // setStripePromise(loadStripe("publishableKey"));
    // });


  fetch("https://km-main-back-update.vercel.app/AllCreateDisCountPrice",{
          method: "GET",
          headers :  {
          "Content-Type" : "application/json" , 
      } ,
      })
      .then(res7=>res7.json())
      .then(res8=>{
       setdiscount(res8)
       })
         

        
            fetch("https://plant-heaven-dubai-main-backs.vercel.app/AllUserCheckoutData",{
                method: "GET",
                 headers :  {
                 "Content-Type" : "application/json" , 
             } ,
            })
            .then(res181=>res181.json())
            .then(res191=>{
                // setNum1111(res191.length)
                let date = new Date()
                let day= date.getDate() 
                let month= (date.getUTCMonth()+1)
                let year= date.getUTCFullYear()
                if(date.getDate() < 10) day = "0"+ date.getDate()
                if(date.getUTCMonth()+1 < 10) month = "0"+ (date.getUTCMonth()+1)
                
                let c = day +""+month+ ""+(year -2000)
                const f = res191.filter((res,i)=>res.Date === c)
                console.log(f.length+1,c)
                setNum1111(f.length+2)
                setNum11(c)
            
            })
            // setot(JSON.parse(localStorage.getItem("CartPrice")) )
            // if(JSON.parse(localStorage.getItem("Custom Img")) )
            // setcustomPhotojson(true )

            // data.map((res,i)=>{
            //     if(res.Product_Catagories === "Custom Products"){
            //         setplay(true)
            //     }
            // })
            fetch("https://plant-heaven-dubai-main-backs.vercel.app/AllUserCheckoutData",{
                method: "GET",
                 headers :  {
                 "Content-Type" : "application/json" , 
             } ,
            })
            .then(res181=>res181.json())
            .then(res191=>{
                setNum1111(res191.length)
            })
          
  fetch("https://plant-heaven-dubai-main-backs.vercel.app/admindata",{
    method: "GET",
     headers :  {
     "Content-Type" : "application/json" , 
 } ,
})
.then(res18=>res18.json())
.then(res19=>{
    setdoctor(res19[0].condition)
    console.log(res19[0].DeliveryCharges,JSON.parse(localStorage.getItem("CartPrice")));
  setadmindataall(res19[0].DeliveryCharges)
console.log(res19[0].DeliveryCharges)
  let j = 0
  let k = 0
//   if(JSON.parse(localStorage.getItem("CartPrice")) < res19[0].condition){
                // j = res19[0].DeliveryCharges
            // }
            // else{
            //     j = 0
            // }
            data.map((item,i)=>{
               j = item.Total_Product_Price + j
               k = item.Pieces + k
            //    if (item.doctor_prescription){
            //     localStorage.setItem("doctor",JSON.stringify(true))
            //    }
            })
            setSubTotal(j)
            setSubPeice(k)
            // var doc =  JSON.parse(localStorage.getItem("doctor")) 
            // setdoctor(doc)

            if(JSON.parse(localStorage.getItem("discount")) && !JSON.parse(localStorage.getItem("discount")).discount2 ){
                setdiscount(JSON.parse(localStorage.getItem("discount")))
                var d = document.getElementById("discount")
                if(JSON.parse(localStorage.getItem("discount")).discount > 1){
                    d.innerHTML = " AED. <b style='font-size:20px'></b>" +JSON.parse(localStorage.getItem("discount")).discount
                    // document.getElementById("ci11").style.visibility = "visible"
                    j = j - parseInt(JSON.parse(localStorage.getItem("discount")).discount)
                }
                else{
                    d.innerHTML = " " +JSON.parse(localStorage.getItem("discount")).discount1 +" % Off"
                    j =j - (j*(JSON.parse(localStorage.getItem("discount")).discount1)/100)
                    
                }
            }else{
                var d = document.getElementById("discount")
                d.innerHTML = "No discount"
                
            }
            
            
            if(JSON.parse(localStorage.getItem("discount")) && JSON.parse(localStorage.getItem("discount")).discount2 ){
                setdiscount(JSON.parse(localStorage.getItem("discount")))
            var d = document.getElementById("discount")
           
            d.innerHTML = " " +JSON.parse(localStorage.getItem("discount")).discount2 +" % Off"
            j =j - (j*(JSON.parse(localStorage.getItem("discount")).discount2)/100)
            


                }

              j =  j+  res19[0].DeliveryCharges



            setot(j.toFixed(0))
            // var t = document.getElementById("subtotal")
            // t.innerHTML = "Rs "+j
            var f = document.getElementById("total")
            f.innerHTML = "AED. " +j.toFixed(0)

        })

        }
        // console.log(total,cart,j)
   else{
    swal("Cart Is Empty")
    props.history.push("/")
            // var t = document.getElementById("subtotal")
            // t.innerHTML = "Rs "+0
            var f = document.getElementById("total")
            f.innerHTML = "AED." +0
   }
  },[])
  

//   useEffect(() => {
  
//     return () => {
//         localStorage.removeItem("doctor")
//     }
//   }, [])

const setCouopon = () =>{
     
        // var d = document.getElementById("discount")
        // var d1 = document.getElementById("discount1")
        // const the = discount.filter((res,i)=> res.name === promo)
        // console.log(the)
        // if(the.length === 0){
        //   swal("Please enter a correct promo code");
        //   document.getElementById("grand-total").innerHTML = total1
        //   localStorage.removeItem("discount")
        //   return
        // }
        // if(the[0].discount === null &&the[0].discount1 === null){
        //   swal("Please enter a correct promo code");
        //   document.getElementById("grand-total").innerHTML = total1
        //   localStorage.removeItem("discount")
        //   return
          
        // }
        // if(the.length > 0){
      
        //   setdiscount6(the[0])
        //   if( the[0].discount > 1){
        //     settot((parseInt(total1) -parseInt(total1) * parseInt(the[0].discount))/100)
        //     // settotal1((total1 * the[0].discount1)/100)
        //     localStorage.setItem("discount",JSON.stringify(the[0]))
        //     // d.innerHTML = "Rs " +the[0].discount
        //     // d.innerHTML = "Discount : "
        //     swal("Update!","Successfully your Promo Applied ", "success");
            
        //   }
        //   else{
            
        //     console.log(total1 -(total1 * the[0].discount1)/100)
        //     settot((parseInt(total1) -(parseInt(total1) * parseInt(the[0].discount1))/100))
        //     // settotal1((total1 * the[0].discount1)/100)
        //     // console.log(total1 , (total1/the[0].discount1))
        //     localStorage.setItem("discount",JSON.stringify(the[0]))
        //     // d.innerHTML = " " +the[0].discount1 +" % Off"
        //     // d.innerHTML = "Discount : "
        //     swal("Update!","Successfully your Promo Applied ", "success");
      
        //   }
        // }
        // else{
        //   swal("Please enter a correct promo code");
        // }
          
        }

    // const SubmitDataMessage1 = () =>{
        // e.preventDefault()

    const SubmitDataMessage1 = (e) =>{
        e.preventDefault()
             console.log(cart,6787 ,customPhotojson, play,tot ,JSON.parse(localStorage.getItem("CartPrice"))-tot , JSON.parse(localStorage.getItem("CartPrice")))
      



            if (cart.length  >= 1 ){

              if(fname === ""){
                swal("Fill The Name");
                 return
             }
             if(Email === ""){
               setEmail("noemail@gmail.com")
              }
              if(Phone === ""){
                 swal("Fill The Phone");
                  return
              }
            
             if(Address === ""){
                swal("Fill The Address");
                 return
             }
             if(City === ""){
                swal("Fill The City");
                 return
             }

                setdisplay(false)
               let j
        if(admindataall > 0){
                 j = admindataall
            }
            else{
                 j = 0
            }
           
            let differnet = {
                DIFFERENTfname,
                DIFFERENTLname ,
                DIFFERENTAddress ,
                DIFFERENTAddress1 ,
                DIFFERENTZipPostal : 1111 ,
                DIFFERENTCity,
                DIFFERENTEmail ,
                DIFFERENTPhone ,
                DIFFERENTOrder_Notes,
            }
                
                console.log(differnet,                Num11," tfgrtg  ",Num1111,
                )



                let das = {}

                if(discount.discount){
                  if(discount.discount > 1)
                das= {
                  name : discount.discount ,
                  type : "R"
                }
                
                // else
                // t = t -  (t * (discount.discount1 / 100))
                
                }
                
                if(discount.discount1)
                das= {
                  name : discount.discount1 ,
                  type : "P"
                }
                
                
                // if(discount.discount2)
                // t = t -  (t * (discount.discount1 / 100))
                


// payment method here 












                    
                                fetch("https://plant-heaven-dubai-main-backs.vercel.app/UsergetDatafromclient",{
                        method: "POST",
                        headers :  {
                            "Content-Type" : "application/json" , 
                        } ,
                        body : JSON.stringify({
                            fname,
                            Lname ,
                            Address ,
                            Address1 ,
                            ZipPostal : 1111 ,
                            City,
                            Email ,
                            Das: das,
                            Phone ,
                            differnet ,
                            Order_Notes,
                            DeliveryCharges:j,
                            discount ,
                               AfterDiscount :  tot ,
                               LessAmount :  JSON.parse(localStorage.getItem("CartPrice"))-tot ,
                               TotalAmount  : JSON.parse(localStorage.getItem("CartPrice")) ,
                            
                            Order : cart,
                            Num123 : Num11+""+Num1111+1,
                        }),
                    })
                    .then(res=>res.json())
                    .then((res2)=>{        
                    if(!res2.Error){
                       
                        setdisplay(true)
                        makePayment()
                        swal("Order placed Successfully");
                       



                            setfName ("")
                            setLName ("" )
                            setAddress  ("")
                            setAddress1 ("" )
                            setZipPostal ("" )
                            setEmail ("" )
                            setCity ("" )
                            setPhone ("" )
                            setOrder_Notes ("")
                        localStorage.removeItem("Cart")
                        localStorage.removeItem("doctor")
                        localStorage.removeItem("SearchData")
                        localStorage.removeItem("Data")
                        localStorage.removeItem("CartPrice")
                        localStorage.removeItem("CateProduct")
                        localStorage.removeItem("discount")
                        localStorage.removeItem("Custom Img")
                        // props.history.push(`/thankyou`)

                     }
                     else{
                      console.log("3")
                        setdisplay(true)
                        swal("Plz Refresh And try Again the Order");
                     }
                  })
                  .catch(err=>{
                    setdisplay(true)
                    swal("There is an Error");
                })









            }
           
            else{
                swal("There is No Any Product in Your Cart");
                setTimeout(()=>{
                    
                    props.history.push(`/`)
                },2000)
            }
        // })
        // }
       
    }
  
















      const makePayment = async()=>{
                console.log("fff")






                // Calculate cart total
const cartTotal = cart.reduce((sum, item) => {
  return sum + item.Total_Product_Price;
}, 0);

// If you have delivery, add it
// const deliveryFee = 25; // example
let deliveryFee; // example
 if(admindataall > 0){
                 deliveryFee = admindataall
            }
            else{
                 deliveryFee = 0
            }
const totalAmount = cartTotal + deliveryFee;

const body = {
  reference_id: Num11 + "" + Num1111 + "1",
  amount: totalAmount.toFixed(2), // <-- total now correct
  currency: "AED",
  items: [
    ...cart.map(item => ({
      item_id: item._id,
      name: item.Product_Name,
      quantity: item.Pieces,
      unit_amount: item.Product_Price_Discounted.toFixed(2),
      discount_type: "flat",
      discount_amount: "0.00",
      total_amount: ( item.Total_Product_Price).toFixed(2),
      net_amount: ( item.Total_Product_Price).toFixed(2)
    })),
    {
      item_id: "delivery",
      name: "Delivery Fee",
      quantity: 1,
      unit_amount: deliveryFee.toFixed(2),
      discount_type: "flat",
      discount_amount: "0.00",
      total_amount: deliveryFee.toFixed(2),
      net_amount: deliveryFee.toFixed(2)
    }
  ],
  discount: "0.00",
  customer: {
    first_name: fname,
    last_name: fname ,
    email: Email || "",
    phone_number: Phone || "",
    business_name: ""
  },
  success_url: `${window.location.origin}/thankyou`,
  failure_url: `${window.location.origin}/checkout`,
  cancelled_url: `${window.location.origin}/`,
  metadata: {}
};









// const cartPrice = JSON.parse(localStorage.getItem("CartPrice")) || 0;

// const body = {
//   reference_id: Num11 + "" + Num1111 + "1",
//   amount: Number(cartPrice).toFixed(2), // ensure it's a number
//   currency: "AED",
//   items: cart.map(item => ({
//     item_id: item._id,
//     name: item.Product_Name,
//     quantity: item.Pieces,
//     unit_amount: item.Product_Price_Discounted.toFixed(2),
//     discount_type: "flat",
//     discount_amount: "0.00",
//     total_amount: (item.Product_Price_Discounted * item.Pieces).toFixed(2),
//     net_amount: (item.Product_Price_Discounted * item.Pieces).toFixed(2)
//   })),
//   discount: "0.00",
//   customer: {
//     first_name: fname,
//     last_name: fname,
//     email: Email || "",
//     phone_number: Phone || "",
//     business_name: ""
//   },
//   success_url: `${window.location.origin}/thankyou`,
//   failure_url: `${window.location.origin}/checkout`,
//   cancelled_url: `${window.location.origin}/`,
//   metadata: {}
// };


fetch("https://plant-heaven-dubai-main-backs.vercel.app/api/nomod-checkout", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(body)
})
  .then(res => res.json())
  .then(data => {
    console.log("Checkout session:", data);
    if (data.url) window.location.href = data.url; // redirect to Nomod
  })
  .catch(err => console.error("Checkout error:", err));






        // const stripe = await loadStripe("pk_live_51RSbkBKyDNhxfO0273lYRlDTckYPEXTKqL0xT8LLaGfhXyo8GL3R1n878yAobbFB9uR8gun4PkaASrHin5Jz5FK700VWvuyoBk");

        // const body = {
        //     products:cart
        // }


        // const headers = {
        //                     "Content-Type" : "application/json" , 
        // }
        // const response = await fetch("http://localhost:3001/create-checkout-session",{
        //     method:"POST",
        //     headers:headers,
        //     body:JSON.stringify(body)
        // });

        // const session = await response.json();

        // const result = stripe.redirectToCheckout({
        //     sessionId:session.id
        // });
        
        // if(result.error){
        //     console.log(result.error);
        // }






    

    }






















    return (
      <div className="page-wrapper">
      
      <main className="main">
        {/* <div className="page-header text-center" style={{backgroundImage: 'url("assets/images/page-header-bg.jpg")'}}>
          <div className="container">
            <h1 className="page-title">Checkout<span>Shop</span></h1>
          </div>
        </div> */}
        <nav aria-label="breadcrumb" className="breadcrumb-nav">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page"  style={{color :  "rgb(163, 209, 51)",fontWeight:"bold"}}>Checkout</li>
            </ol>
          </div>{/* End .container */}
        </nav>{/* End .breadcrumb-nav */}
        <div className="page-content">
          <div className="checkout">
            <div className="container">
              <div className="checkout-discount">
                <form action="#">
                  <input type="text" className="form-control" required id="checkout-discount-input" />
                  <label htmlFor="checkout-discount-input" className="text-truncate">Have a coupon? <Link to="/cart"><span>Click here to enter your code</span></Link> </label>
                </form>
              </div>{/* End .checkout-discount */}
              
           
              {/* <form onSubmit={(e)=>makePayment(e)}> */}
              <form onSubmit={(e)=>SubmitDataMessage1(e)}>
                <div className="row">
                  <div className="col-lg-9">
                    <h2 className="checkout-title">Billing Details</h2>{/* End .checkout-title */}
                    <div className="row">
                      <div className="col-sm-12">
                        <label>Full Name *</label>
                        <input type="text" className="form-control" required value={fname} onChange={(e)=>setfName(e.target.value)} placeholder="Enter Full Name"/>
                      </div>{/* End .col-sm-6 */}
                      {/* <div className="col-sm-6">
                        <label>Last Name *</label>
                        <input type="text" className="form-control" required />
                      </div> */}
                      {/* End .col-sm-6 */}
                    </div>{/* End .row */}
                    {/* <label>Company Name (Optional)</label>
                    <input type="text" className="form-control" /> */}
                    {/* <label>Country *</label>
                    <input type="text" className="form-control" required  placeholder="Enter Country"  value={Country} onChange={(e)=>setCountry(e.target.value)} /> */}
                    <label>Street address *</label>
                    <input type="text" className="form-control" required  placeholder="Enter Address including house no, Block and town"  value={Address} onChange={(e)=>setAddress(e.target.value)} />
                    {/* <input type="text" className="form-control" placeholder="Appartments, suite, unit etc ..." required   value={Address1} onChange={(e)=>setAddress1(e.target.value)} /> */}
                    <div className="row">
                      <div className="col-sm-12">
                        <label>Town / City *</label>
                        <input type="text" className="form-control" required  placeholder="Enter City" value={City} onChange={(e)=>setCity(e.target.value)}/>
                      </div>{/* End .col-sm-6 */}
                      {/* <div className="col-sm-6">
                        <label>State / County *</label>
                        <input type="text" className="form-control" required />
                      </div> */}
                      {/* End .col-sm-6 */}
                    </div>{/* End .row */}
                    <div className="row">
                      {/* <div className="col-sm-6">
                        <label>Postcode / ZIP *</label>
                        <input type="text" className="form-control" required  placeholder="Enter Postcode / ZIP Number"  value={ZipPostal} onChange={(e)=>setZipPostal(e.target.value)}/>
                      </div>End .col-sm-6 */}
                      <div className="col-sm-12">
                        <label>Phone *</label>
                        <input type="tel" className="form-control"  placeholder="Enter Mobile Number"  required value={Phone} onChange={(e)=>setPhone(e.target.value)}  />
                      </div>{/* End .col-sm-6 */}
                    </div>{/* End .row */}
                    <label>Email address *</label>
                    <input type="email" className="form-control"  placeholder="Enter E-mail" required  value={Email} onChange={(e)=>setEmail(e.target.value)}  />
                    {/* <div className="custom-control custom-checkbox">
                      <input type="checkbox" className="custom-control-input" id="checkout-create-acc" />
                      <label className="custom-control-label" htmlFor="checkout-create-acc">Create an account?</label>
                    </div> */}
                    {/* End .custom-checkbox */}
                    {/* <div className="custom-control custom-checkbox">
                      <input type="checkbox" className="custom-control-input" id="checkout-diff-address" />
                      <label className="custom-control-label" htmlFor="checkout-diff-address">Ship to a different address?</label>
                    </div> */}
                    {/* End .custom-checkbox */}
                    <label>Order notes (optional)</label>
                    <textarea className="form-control" cols={30} rows={4} placeholder="Notes about your order, e.g. special notes for delivery" defaultValue={""}  value={Order_Notes} onChange={(e)=>setOrder_Notes(e.target.value)} />
                  </div>{/* End .col-lg-9 */}
                  <aside className="col-lg-3">
                    <div className="summary">
                      <h3 className="summary-title">Order Details</h3>{/* End .summary-title */}
                      <table className="table table-summary table-summary1">
                        <thead>
                          <tr>
                            <th  style={{fontWeight:"600",color:"black"}}>Product</th>
                            <th  style={{fontWeight:"600",color:"black"}}>Pieces</th>
                            <th  style={{fontWeight:"600",color:"black"}}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                                                    cart && cart.map((item,i)=>{
                                                      if(item.Price[0]){
                                                        return(
                                                          <tr>
                                                            <td><a >{item.Product_Name}   </a>  <span style={{paddingLeft  :"30px"}}>{item.Size.length > 2 ? "Color : " :  "Size : "}  {item.Size}</span>  </td>
                                                            <th>x {item.Pieces}</th>
                                                            <td>AED.{(item.Total_Product_Price).toFixed(0)}</td>
                                                          </tr>
                                                          )
                                                        }
                                                        else{
                                                          return(
                                                            <tr>
                                                              <div  style={{maxWidth:"90%",maxHeight : "76px",overflow : "hidden"}}>
                                                              <td  style={{textAlign : "left"}}>
                                                                {item.Product_Name}
                                                              </td>
                                                              </div>
                                                              <th>x {item.Pieces}</th>
                                                              <td>AED.{(item.Total_Product_Price).toFixed(0)}</td>
                                                            </tr>
                                                            )
                                                        }
                                                        })
                                                          }
{/* //                                                           <tr>
//                                                           <td><a >Beige knitted elastic runner shoes</a></td>
//                                                           <td>AED.84.00</td>
//                                                         </tr>



//                                                             <div className="d-flex justify-content-between">  
//                                                                 {item.Price[0] ?
//         <p> <div>
//         <span className='text-truncate' style={{color : "black",width: "142px"}}>{item.Product_Name}</span>
//         <span style={{paddingLeft  :"30px"}}>{item.Size.length > 2 ? "Color : " :  "Size : "}  {item.Size}</span>
//       </div></p>

//  :
//  <p className='text-truncate' style={{color : "black",width: "142px"}}> {item.Product_Name }</p>
// } 

// <p>x {item.Pieces}</p>
//                     <p>Rs {(item.Total_Product_Price).toFixed(0)}</p>
//                                                             </div>
                                                  
// )
//                                                     })
//                                                 } */}
                          {/* <tr>
                            <td><a >Beige knitted elastic runner shoes</a></td>
                            <td>AED.84.00</td>
                          </tr>
                          <tr>
                            <td><a >Blue utility pinafore denimdress</a></td>
                            <td>AED.76,00</td>
                          </tr> */}
                          <tr className="summary-subtotal sub-total-border">
                            <td>Subtotal . {SubPeice} items</td>
                            <td></td>
                            <td>AED.{SubTotal}</td>
                          </tr> 
                          
                          {/* End .summary-subtotal sub-total-border */}
                          <tr className="summary-subtotal sub-total-border">
                            <td>Shipping</td>
                            <td></td>


                            <td>{ admindataall > 0 ?
                                                            "AED. "+admindataall
                                                            : 
                                                            <b>25</b>
                                                         }</td>
                          </tr>
                          {JSON.parse(localStorage.getItem("discount")) ?

                          <tr className="summary-subtotal sub-total-border">
                            <td>Discount</td>
                            <td></td>

                            <td id="discount"></td>
                          </tr>
                          : ""
}
                          <tr className="summary-total">
                            <td style={{fontWeight:"bold",fontSize:"1.7rem"}}>Total</td>
                            <td></td>

                            <td style={{fontWeight:"bold",fontSize:"1.7rem"}} id="total">AED.</td>
                          </tr>{/* End .summary-total */}
                        </tbody>
                      </table>{/* End .table table-summary */}
                      <div className="accordion-summary" id="accordion-payment">
                       
                        
                        <div className="card">
                          <div className="card-header" id="heading-3">
                            <h2 className="card-title">
                              {/* <a className="collapsed" role="button" value={true} data-toggle="collapse" href="#collapse-3" aria-expanded="false" aria-controls="collapse-3"> */}
                              <input type="radio" name="" id="" checked value={true} style={{marginRight: "10px"}}/>
                                Cash on delivery
                              {/* </a> */}
                            </h2>
                          </div>{/* End .card-header */}
                          <div id="collapse-3" className="collapse" aria-labelledby="heading-3" data-parent="#accordion-payment">
                            <div className="card-body">Quisque volutpat mattis eros. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. 
                            </div>{/* End .card-body */}
                          </div>{/* End .collapse */}
                        </div>{/* End .card */}
                        
                       
                      </div>{/* End .accordion */}
                      <button type="submit" className="btn btn-outline-primary-2 btn-order btn-block uihuihiuh"  style={{padding : "14px 38px",background :"#008071",color:"white",fontSize:"large"}}>
                        <span className=""  style={{padding : "-4px 38px",fontSize:"large"}}>Place Order</span>
                        {/* <span className="btn-hover-text">Proceed to Checkout</span> */}
                      </button>

                    </div>{/* End .summary */}
                  </aside>{/* End .col-lg-3 */}
                </div>{/* End .row */}
              </form>
            </div>{/* End .container */}
            <td id="discount" style={{color:"white",display:"none"}}></td>

          </div>{/* End .checkout */}
        </div>{/* End .page-content */}

      </main>{/* End .main */}
    </div>
        )
    
}

export default Checkout;